import CloseIcon from '@mui/icons-material/Close';
import React from 'react'
import { Dropdown, Form, Modal, Toast } from 'react-bootstrap'
import { useState } from 'react'
import { useContext } from 'react'
import { AuthContext } from '../../../context/AuthContext'
import axios from 'axios'
import dateFormat from 'dateformat';
import { useParams } from 'react-router-dom'
import ENDPOINT from '../../../data/ENDPOINT'
import DuoIcon from '@mui/icons-material/Duo';
import VideoIcon from '@mui/icons-material/Videocam';
import { Call, Chat, Duo, PhoneAndroid, PhoneCallback, VideoCall, WhatsApp } from '@material-ui/icons'
import { Chip, CircularProgress } from '@material-ui/core'
import { useEffect } from 'react'
import { PlayCircle } from '@mui/icons-material'
import { Alert, Snackbar } from '@mui/material'
import StarIcon from '@mui/icons-material/Star';
import WhatsAppIcon from '@mui/icons-material/WhatsApp';
import { Box } from '@material-ui/core'
import { Rating } from '@mui/material'
import AddIcCallIcon from '@mui/icons-material/AddIcCall';
import Localbase from 'localbase';
import callsprt from '../../../../src/assets/images/callsupport.png';
import chatsprt from '../../../../src/assets/images/chatsupport.png';
import zoomsprt from '../../../../src/assets/images/zoomsprt.png';
import coin from '../assets/coin.png'

const StudentSupport = ({ props, account }) => {
  const db = new Localbase('db')
  const { course_url, batch_id } = useParams();
  const { user } = useContext(AuthContext)
  const params = useParams();
  const courseurl = params.course_url;
  const batchid = params.batch_id;
  const [chat, setchat] = useState(false);
  const [subject, setsubject] = useState(null);
  const [message, setmessage] = useState(null);
  const [messageerror, setmessageerror] = useState(null);
  const [subjecterror, setsubjecterror] = useState(null);
  const [category, setcategory] = useState(null);
  const [callback, setcallback] = useState(false)
  const [discussions, setDiscussions] = useState(null)

  const [doubtStatistics, setDoubtStatistics] = useState({
    doubt_limit: 3000,
    doubt_score: 0,
    request_permission: true
  })

  const getDoubts = async () => {


    const formData = new FormData();
    formData.append('session', user.SessionId);
    formData.append('course', course_url);
    formData.append('batch_id', batch_id);


    const res = await axios.post(ENDPOINT + "get-discussions.php", formData, {
      headers: {
        'content-type': 'multipart/form-data'
      }
    });
    if (res) {

      if (res.data.status === "success") {
        setDiscussions(res.data.doubts)
        setDoubtStatistics(res.data.statistics)
        setstatistics(res.data.statistics)
        db.collection('paths').add({ discussions: res.data.doubts }, ("trainer-support-" + JSON.stringify(course_url + batch_id)))
        db.collection('paths').add({ discussionsScore: res.data.statistics }, ("trainer-support-score" + JSON.stringify(course_url + batch_id)))
      }
      else {

      }
    }
  }

  const [loading, setloading] = useState(false)

  const sendRequest = async (cat) => {
    if (!doubtStatistics.request_permission) {
      settoasttitle("Request Disabled");
      settoastmessage("You have reached your credit points limit or do not have permission to request support at this time.");
      settoast(true);
      return;
    }
    setloading(true)
    setcategory(cat);
    const formData = new FormData();
    //formData.append('whyus',document.getElementById('whyus').value)

    formData.append('session', user.SessionId);
    formData.append('course', courseurl);
    formData.append('batch_id', batchid);
    formData.append('subject', subject);
    formData.append('message', message);
    formData.append('category', cat);

    const res = await axios.post(ENDPOINT + "whatsapp-chat.php", formData, {
      headers: {
        'content-type': 'multipart/form-data'
      }
    });
    if (res) {
      setloading(false)
      //console.log("doubt support"+JSON.stringify(res.data))
      if (res.data.status === "success") {
        settoast(true);
        settoasttitle("Request Sent");
        settoastmessage("Your support request has been sent successfully. Our team will get in touch with you shortly.");
        setchat(false);
        setcallback(false)
        getDoubts();
        if (cat === "chat") {
          window.open("https://wa.me/919986783238?text=*Discussion%20ID*:%20%20"
            + res.data.discussion_id + "%20%20*Course%20ID*:" + courseurl + "%20%20*Batch%20ID*:" + batchid);
        }
      }
      else {
        settoast(true);
        settoasttitle("Something went wrong !");
        settoastmessage("Please try after sometime")
        setchat(false);
        setcallback(false)

      }
    }
  }

  const [statistics, setstatistics] = useState(null)

  const [read, setread] = useState(false)
  const [watch, setwatch] = useState(false)

  const Getofflinedata = () => {
    db.collection('paths').doc(("trainer-support-" + JSON.stringify(courseurl + batchid))).get().then((data) => {
      if (data) {
        setDiscussions(data.discussions)
      }
    }).catch(() => { })
    db.collection('paths').doc(("trainer-support-score" + JSON.stringify(courseurl + batchid))).get().then((data) => {
      if (data) {
        // console.log(data.discussionsScore.doubt_score);
        setDoubtStatistics(data.discussionsScore)

      }
    }).catch(() => { })
  }
  useEffect(() => {
    Getofflinedata()
  }, [])


  useEffect(() => {
    window.scrollTo(0, 0)
    //  //console.log("getting doubts")
    getDoubts()
  }, [account])


  const [query, setquery] = useState(null)

  const [feedback, setfeedback] = useState(false)
  const [toast, settoast] = useState(false);
  const [toasttitle, settoasttitle] = useState(null)
  const [doubtid, setdoubtid] = useState(null)
  const [toastmessage, settoastmessage] = useState(null)

  const [studentfeedback, setstudentfeedback] = useState(null);
  const [rating, setrating] = useState(3)
  const SubmitFeedback = async () => {

    const formData = new FormData();
    formData.append('session', user.SessionId);
    formData.append('doubt_id', doubtid);
    formData.append('rating', rating);
    formData.append('feedback', studentfeedback);

    const res = await axios.post(ENDPOINT + "submit-doubt-feedback.php", formData, {
      headers: {
        'content-type': 'multipart/form-data'
      }
    });
    if (res) {

    }

    if (res.data.status === "success") {
      setfeedback(false)
      settoasttitle("Feedback submitted");
      settoastmessage("Thank you for submitting your feedback")
      setstudentfeedback(null)
      setrating(3)
      settoast(true)
      getDoubts()

    }
    else {
      settoasttitle("Something went wrong !");
      settoastmessage("Please try after sometime")
      settoast(true)
    }
  }

  const labels = {
    0.5: 'Useless',
    1: 'Bad',
    1.5: 'Poor',
    2: 'Ok',
    2.5: 'Below Average',
    3: 'Average',
    3.5: 'Good',
    4: 'Better',
    4.5: 'Best',
    5: 'Excellent',
  };

  const [hover, setHover] = React.useState(-1);

  const [note, setnote] = useState(null)
  const [duobtsubject, setdoubtsubject] = useState(null)
  const [doubtqsn, setdoubtqsn] = useState(null)
  const ReadResolution = ({ index }) => {
    setread(true)
    setnote(discussions[index].note || null)
    setdoubtsubject(discussions[index].subject || null)
    setdoubtqsn(discussions[index].message || null)

  }
  const [responsevideo, setresponsevideo] = useState(null)

  const WatchResolution = ({ index }) => {

    setnote(discussions[index].note || null)
    setdoubtsubject(discussions[index].subject || null)
    setdoubtqsn(discussions[index].message || null)
    setresponsevideo(discussions[index].recording_link)
    setwatch(true)
  }
  // console.log(doubtStatistics);
  return (
    <>




      <div className="w-100 doubt-sup bg-white">
        {/* /* Add animation for credit score pop effect */}
        <style>
          {`.credit-score-animate {
  animation: popScore 0.8s cubic-bezier(0.23, 1, 0.32, 1);
}
@keyframes popScore {
  0% { transform: scale(0.7); opacity: 0.5; }
  60% { transform: scale(1.15); opacity: 1; }
  100% { transform: scale(1); opacity: 1; }
}`}
        </style>

        <div className="toast-container">


          {/* <Toast className="bg-warning" onClose={() => settoast(false)} show={toast} delay={3000} autohide>
            <Toast.Header>

              <strong className="me-auto">{toasttitle}</strong>

            </Toast.Header>
            <Toast.Body>{toastmessage}</Toast.Body>
          </Toast> */}


          <Snackbar>
            <Alert onClose={() => settoast(false)} severity="info" sx={{ width: '100%' }}>
              {toastmessage}
            </Alert>
          </Snackbar>
        </div>
        <Modal
          {...props}

          aria-labelledby="contained-modal-title-vcenter"
          centered

          show={callback}
          onHide={() => { setcallback(false) }}
        >

          <Modal.Body>

            <div className="container-fluid">
              <div className="flex space-between mb-4 w-100 ">
                <h5 className='text-dark'>Request</h5>
                <CloseIcon type="button" onClick={() => { setcallback(false) }} className="text-danger" />
              </div>


              <Form.Group className="mb-3" controlId="formBasicEmail">
                <Form.Label >Subject </Form.Label>
                <Form.Control type="text" required value={subject ? subject : null} onChange={(e) => { setsubject(e.target.value) }} placeholder="Example: I have doubts on a topic" />
                {subjecterror ?
                  <Form.Text className="text-danger">
                    {subjecterror}
                  </Form.Text>
                  : null}
              </Form.Group>

              <Form.Group className="mb-3" controlId="formBasicPassword">
                <Form.Label>Message / Doubt</Form.Label>
                <Form.Control type="text" required value={message ? message : null} onChange={(e) => { setmessage(e.target.value) }} placeholder="Example: what is AI ?" />
                {messageerror ?
                  <Form.Text className="text-danger">
                    {messageerror}
                  </Form.Text>
                  : null}
              </Form.Group>

              <div className=" mt-4">
                <button className="btn btn-primary w-100" type="submit" disabled={loading} onClick={() => { sendRequest(category) }}> {loading ? "Confirming..." : "Confirm Request"}</button>

              </div>





            </div>





          </Modal.Body>

        </Modal>




        <Modal
          {...props}

          aria-labelledby="contained-modal-title-vcenter"
          centered

          show={feedback}
          onHide={() => { setfeedback(false) }}
        >

          <Modal.Body>

            <div className="container-fluid">
              <div className="flex space-between mb-4 w-100">
                <h5>Support Feedback</h5>
                <CloseIcon type="button" onClick={() => { setfeedback(false) }} className="text-danger" />
              </div>


              <Box
                sx={{
                  width: 200,
                  display: 'flex',
                  alignItems: 'center',
                }}
              >

                <Rating
                  name="hover-feedback"
                  value={rating}
                  precision={0.5}
                  onChange={(event, newValue) => {
                    setrating(newValue);
                  }}
                  onChangeActive={(event, newHover) => {
                    setHover(newHover);
                  }}
                  emptyIcon={<StarIcon style={{ opacity: 0.55 }} fontSize="inherit" />}
                />
                {rating !== null && (
                  <Box sx={{ ml: 2 }}>{labels[hover !== -1 ? hover : rating]}</Box>
                )}
              </Box>


              <Form.Group className="mb-3" >
                <Form.Label>Feedback</Form.Label>
                <Form.Control type="text" required value={studentfeedback ? studentfeedback : null} onChange={(e) => { setstudentfeedback(e.target.value) }} placeholder="Feedback" />
                {messageerror ?
                  <Form.Text className="text-danger">
                    {messageerror}
                  </Form.Text>
                  : null}
              </Form.Group>

              <div className=" mt-4">
                <button className="btn btn-primary w-100" type="submit" onClick={() => { SubmitFeedback() }}> Submit Feedback</button>

              </div>


            </div>

          </Modal.Body>

        </Modal>


        <Modal
          {...props}

          animation={false}
          centered
          size="sm"
          className="bg-transparent"
          show={chat}
          onHide={() => { setchat(false) }}
        >

          <Modal.Body className="bg-transparent">
            <div className="text-center">
              <p>Connecting...</p>
              <CircularProgress color="success" />
            </div>

          </Modal.Body>

        </Modal>


        <Modal
          {...props}

          animation={false}
          centered
          size="lg"
          className="bg-transparent"
          show={read}
          onHide={() => { setread(false) }}
        >

          <Modal.Body className="bg-transparent">
            <div className="flex space-between">
              <h4 className="text-primary">Summary</h4>
              <CloseIcon className="text-danger" type="button" onClick={() => setread(false)} />
            </div>
            <hr />
            <div className="t">

              <p><b>Subject : </b>{duobtsubject}</p>
              <p><b>Question : </b>{doubtqsn}</p>
              {note ?
                <>
                  <b>Discussion Summary : </b>
                  <p>{note}</p>
                </> :
                <>
                  <p className="text-secondary">No discussion summary for this support request</p>
                </>}
            </div>

          </Modal.Body>

        </Modal>


        <Modal
          {...props}

          animation={false}
          centered
          size="lg"
          className="bg-transparent"
          show={watch}
          onHide={() => { setwatch(false) }}
        >

          <Modal.Body className="bg-transparent">
            <div className="t">
              <div className="flex-wrap p-2">
                <h3>Trainer Response Summary</h3>
              </div>
              <hr />
              <p><b>Subject : </b>{duobtsubject}</p>
              <p><b>Question : </b>{doubtqsn}</p>

              <video className="w-100" src={responsevideo}></video>


            </div>

          </Modal.Body>

        </Modal>
        {/* SUPPORT HERO */}
        {/* SUPPORT HERO */}
        <div className="w-100 position-relative pt-5 pb-5 doubt-support">

          {/* FULL WIDTH HEADER */}
          <div className="container-fluid px-4 px-md-5">

            <div className="d-flex justify-content-between align-items-center flex-wrap mb-4">

              <div>
                <h2 className="text-light mb-1">24/7 Doubt Support</h2>
                <p className="text-light opacity-75 mb-0">
                  Choose how you'd like to connect with your trainer
                </p>
              </div>

              <div className="d-flex align-items-center bg-white rounded-pill px-3 py-2 shadow-sm mt-3 mt-md-0">
                <img src={coin} style={{ height: 22 }} />
                <span className="ms-2 fw-semibold text-dark">
                  {doubtStatistics.doubt_limit}
                </span>
              </div>

            </div>

          </div>


          {/* RESPONSIVE CARDS */}
          <div className="container-fluid px-4 px-md-5">

            <div className="row g-4">

              {/* CHAT */}
              <div className="col-12 col-md-6 col-lg-4">
                <div className="card border-0 shadow h-100">
                  <img
                    src={chatsprt}
                    className="card-img-top"
                    style={{ height: "200px", objectFit: "cover" }}
                  />
                  <div className="card-body text-center">
                    <h5 className="fw-bold mb-0 pb-0">Discuss over Chat</h5>
                    <p className="text-muted small">Start WhatsApp instantly</p>
                    <button
                      className="btn btn-success rounded-pill w-100 mt-2"
                      disabled={loading || !doubtStatistics.request_permission}
                      onClick={() => {
                        setcategory("chat");
                        setcallback(true);
                      }}
                    >
                      <WhatsApp className="me-2" />
                      Start Chat
                    </button>
                  </div>
                </div>
              </div>

              {/* CALLBACK */}
              <div className="col-12 col-md-6 col-lg-4">
                <div className="card border-0 shadow h-100">
                  <img
                    src={callsprt}
                    className="card-img-top"
                    style={{ height: "200px", objectFit: "cover" }}
                  />
                  <div className="card-body text-center">
                    <h5 className="fw-bold mb-0 pb-0">Receive a Callback</h5>
                    <p className="text-muted small">Trainer calls you</p>
                    <button
                      className="btn btn-primary rounded-pill w-100 mt-2"
                      disabled={loading || !doubtStatistics.request_permission}
                      onClick={() => {
                        setcategory("callback");
                        setcallback(true);
                      }}
                    >
                      <PhoneAndroid className="me-2" />
                      Request Call
                    </button>
                  </div>
                </div>
              </div>

              {/* ZOOM */}
              <div className="col-12 col-md-12 col-lg-4">
                <div className="card border-0 shadow h-100">
                  <img
                    src={zoomsprt}
                    className="card-img-top"
                    style={{ height: "200px", objectFit: "cover" }}
                  />
                  <div className="card-body text-center">
                    <h5 className="fw-bold mb-0 pb-0">Zoom Session</h5>
                    <p className="text-muted small">For complex doubts</p>
                    <button
                      className="btn btn-danger rounded-pill w-100 mt-2"
                      disabled={loading || !doubtStatistics.request_permission}
                      onClick={() => {
                        setcategory("zoom");
                        setcallback(true);
                      }}
                    >
                      <VideoIcon className="me-2" />
                      Schedule Meet
                    </button>
                  </div>
                </div>
              </div>

            </div>

          </div>

        </div>

        <div className="container mt-5  sm-p-15">
          <div className="">
            <div className="flex align-items-center space-between">

              <h3 className="sm-22">Recent Discussions </h3>

            </div>
            <hr />
            {statistics ?
              <>
                {statistics.closed > 0 ?

                  <>
                    <>
                      <p>Average Response Time : {statistics.avg_response_time >= 60 ?
                        <>
                          {(statistics.avg_response_time / 60)} Hours
                        </>
                        :
                        <>
                          {(statistics.avg_response_time)} Minutes
                        </>
                      }</p>


                      <Alert variant="outlined" severity="info">
                        On an average,<b> we took {statistics ? statistics.avg_response_time : null} minutes to resolve most of your doubts</b>. Please submit a feedback of all your support requests to help us serve you better.
                      </Alert>

                    </>
                  </>
                  : null
                }
              </>
              : null
            }


          </div>


          <div className="pb-5">
            {discussions ?

              <>

                <div className="container-fluid border rounded mt-3 mb-3 p-3">
                  <div className="flex-wrap align-items-center">
                    {discussions.map((discussion) => (
                      <div className="col-12 px-0 px-md-2" key={discussion.id}>
                        <div className="card shadow-sm border-0 mb-3">

                          <div className="card-body">

                            <div className="d-flex justify-content-between flex-wrap gap-2">

                              <div className="d-flex flex-column">

                                <span className="fw-semibold">Discussion ID: {discussion.id}</span>

                                <small className="text-muted">
                                  {dateFormat(discussion.create_datetime, "dS mmm yyyy")}
                                </small>

                              </div>

                              <span
                                className={`badge d-flex align-items-center ${discussion.status === 'closed'
                                  ? 'bg-success-subtle text-success'
                                  : discussion.status === 'pending'
                                    ? 'bg-warning-subtle text-warning'
                                    : 'bg-secondary-subtle text-secondary'
                                  }`}
                              >
                                {discussion.status}
                              </span>

                            </div>

                            <hr />

                            <div className="d-flex justify-content-between align-items-center">

                              <div>
                                {discussion.category === "chat" && <WhatsAppIcon color="success" />}
                                {discussion.category === "zoom" && <VideoCall color="error" />}
                                {discussion.category === "callback" && <AddIcCallIcon color="primary" />}
                              </div>

                              {discussion.rating == 0 && (
                                <button
                                  className="btn btn-outline-primary btn-sm"
                                  onClick={() => {
                                    setdoubtid(discussion.id);
                                    setfeedback(true);
                                  }}
                                >
                                  Submit Feedback
                                </button>
                              )}

                            </div>

                          </div>
                        </div>

                      </div>


                    ))}
                  </div>
                </div>




              </>
              :

              <>

              </>

            }
          </div>
        </div>

      </div >

    </>
  )
}

export default StudentSupport
